import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import Store from '.';
import { AgencyStore } from './agencyStore';
import { BlocklistStore } from './blocklistStore';

export default function useStore(): { store: Store; agencyStore: AgencyStore; blocklistStore: BlocklistStore } {
    const { store } = useContext(MobXProviderContext);
    const { agencyStore, blocklistStore } = store;
    return { store, agencyStore, blocklistStore };
}
